import styled from '@emotion/styled';

export const EntitlementIconWrapper = styled.div`
  > img {
    border-radius: 0;
  }
`;
